// extracted by mini-css-extract-plugin
module.exports = {"formContainer":"LoginBox_formContainer__7E_SE"};